import { observer } from 'mobx-react';
import { AutoSizer, List } from 'react-virtualized';
import dictionary from '../../../Mobx/Dictionary';
import DictionaryCard from './DictionaryCard';

const DictionaryList = observer(() => {
    // _________________________________________________________________________________________
    const data = dictionary.current.data[dictionary.current.dictionaryType] || [];
    const currentIndex = dictionary.current.value.index || -1;
    const rowRenderer = ({ key, index, style }) => {
        const item = data[index];
        const isSelected = index === currentIndex;

        return (
            <div key={key} style={style} className="list-item">
                <DictionaryCard
                    data={item}
                    isSelected={isSelected}
                    number={index + 1}
                />
            </div>
        );
    };



    // _________________________________________________________________________________________
    return (
        <AutoSizer
            key={ // This is to force the list to re-render when the rowHeight changes or the dictionary type changes
                dictionary.current.dictionaryType +
                dictionary.current.sort?.field +
                dictionary.current.sort?.order +
                dictionary.dataChanged
            }
        >
            {({ width, height }) => (
                <List
                    width={width - 5}
                    height={height - 6}
                    rowCount={data.length}
                    rowHeight={125}
                    rowRenderer={rowRenderer}
                    scrollToIndex={currentIndex !== -1 ? currentIndex : 0}
                    scrollToAlignment="center"
                />
            )}
        </AutoSizer>
    );
});

export default DictionaryList;
